import { replaceSpecialChars } from 'cpool-utils';
import { z } from 'zod';

export const schemaConsorsPlaceOfBirth = z
    .string()
    .min(2)
    .max(32)
    .transform(replaceSpecialChars)
    .refine((value) => /^[a-zA-ZßäöüÖÄÜ./() -]+$/u.test(value), {
        message: 'Invalid characters',
    });
